import React from "react";
import AppProvider from "providers/AppProvider";
import AppRoutes from "routing";
import StoreProvider from "./providers/StoreProvider";

function App() {
  return (
    <StoreProvider>
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </StoreProvider>
  );
}

export default App;
